import { connect } from 'react-redux';
import Container from './container';
import mapStateToProps from './mapStateToProps';
import { mapDispatchToProps } from './mapDispatchToProps';
import withInsuranceValidation from '../../gql/withInsuranceValidation';

const withProviderDataAndInsuranceValidation = withInsuranceValidation(Container);
const connected = connect(mapStateToProps, mapDispatchToProps)(withProviderDataAndInsuranceValidation);

export { connected as default };
